import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { Range, getTrackBackground } from 'react-range';
require('./style.css');

interface IProps {
	label?: string;
	step: number;
	availableMin: number;
	availableMax: number;
	selectedValues: number[];

	/* functions props */
	t?: (key: string) => string;
	onValuesChange?: (values: number[]) => void;
	onFinalValuesChange: (values: number[]) => void;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class RangeFilter extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { step, availableMax, availableMin, onFinalValuesChange, onValuesChange, selectedValues, label } = this.props;

		if (
			!(
				availableMin !== null &&
				availableMax !== null &&
				selectedValues &&
				selectedValues[0] >= availableMin &&
				selectedValues[1] <= availableMax &&
				step !== null &&
				availableMin < availableMax
			)
		) {
			return null;
		}

		return (
			<>
				{label && label.length > 0 ? <div className="filterRangeLabel">{label}</div> : null}
				<div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }} className="filterRangeWrapper">
					<Range
						values={selectedValues}
						step={step}
						min={availableMin}
						max={availableMax}
						onChange={onValuesChange}
						onFinalChange={onFinalValuesChange}
						renderTrack={({ props, children }) => (
							<div
								onMouseDown={props.onMouseDown}
								onTouchStart={props.onTouchStart}
								style={{
									...props.style,
									height: '36px',
									display: 'flex',
									width: '100%',
								}}
								className="filterRange"
							>
								<div
									ref={props.ref}
									style={{
										height: '3px',
										width: '100%',
										borderRadius: '4px',
										background: getTrackBackground({
											values: selectedValues,
											colors: ['#ccc', '#000', '#ccc'],
											min: availableMin,
											max: availableMax,
										}),
										alignSelf: 'center',
									}}
								>
									{children}
								</div>
							</div>
						)}
						renderThumb={({ index, props, isDragged }) => (
							<div
								{...props}
								style={{
									...props.style,
									height: '15px',
									width: '15px',
									backgroundColor: '#FFF',
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									boxShadow: '0px 2px 6px #AAA',
								}}
								className="filterRangeDots"
							>
								<div
									style={{
										position: 'absolute',
										top: '-23px',
										color: '#000',
										fontWeight: 'bold',
										fontSize: '10px',
										fontFamily: 'IBMPlexSans,sans-serif',
										padding: '4px',
										borderRadius: '4px',
										backgroundColor: 'transparent',
									}}
								>
									{selectedValues[index]}
								</div>
								<div
									style={{
										height: '10px',
										width: '5px',
										backgroundColor: isDragged ? '#fff' : '#fff',
									}}
								/>
							</div>
						)}
					/>
				</div>
			</>
		);
	}
}

export { RangeFilter };
